import React, { useEffect, useState } from 'react';
import { SlashLink as Link } from './SlashLink';
import { findInProgressMocks } from '../utils/activeSitting';
import { sittingTokenOwner } from '../utils/quizServer';
import { phiTrack } from '../utils/phiTrack';
import { syncRemoteSittings } from '../utils/remoteSitting';

function formatClock(totalSeconds) {
  const s = Math.max(0, Math.round(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  return h ? `${h}h ${String(m).padStart(2, '0')}m` : `${m}m`;
}

/**
 * "Continue Mock N" prompt for a mock left part-way. The exam clock is paused while the page is
 * closed (applyBreakCredit), so the time shown is what the student had left. Signed in, a mock
 * started on another device shows here too: its mirrored copy is stored locally first
 * (syncRemoteSittings), and a newer copy from either side wins.
 */
export default function ContinueMockCard({ uid = '', placement = 'unknown' }) {
  const [mock, setMock] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let viewed = '';
    const show = (source) => {
      if (cancelled) return [];
      const found = findInProgressMocks({ ownerUid: uid, tokenOwner: sittingTokenOwner });
      const latest = found[0] || null;
      setMock(latest);
      const seen = latest ? `${latest.formId}:${latest.currentQuestion}` : '';
      if (latest && seen !== viewed) {
        viewed = seen;
        phiTrack('continue_mock_view', { placement, formId: latest.formId, answered: latest.answered, source });
      }
      return found;
    };
    const local = show('local');
    if (uid) {
      // Best effort: never rejects, and the local card above stays if Firestore is slow or down.
      syncRemoteSittings({ uid, localMocks: local })
        .then((changed) => {
          if (changed) show('remote');
        })
        .catch(() => {});
    }
    return () => {
      cancelled = true;
    };
  }, [uid, placement]);

  if (!mock) return null;

  return (
    <div className="progress-next continue-mock-card" data-testid="continue-mock-card">
      <div>
        <h2>Continue Mock {mock.formId}</h2>
        <p>
          You stopped at question {mock.currentQuestion} of {mock.total} ({mock.answered} answered).
          Your clock is paused with {formatClock(mock.remainingSeconds)} left.
        </p>
      </div>
      <Link
        className="btn-primary"
        to={mock.path}
        onClick={() => phiTrack('continue_mock_click', { placement, formId: mock.formId })}
      >
        Continue
      </Link>
    </div>
  );
}
